import {
    BANK_SEPA_CANCELED,
    BANK_SEPA_IN,
    BANK_TABEO,
    BANK_SPLIT_IT,
    BANK_TRANSFER_IN,
    BANK_TRANSFER_OUT,
    BANK_ZAB,
    BANK_PLEDG,
} from '../../../constant/payment-constant'

export const REDUCER_NAME = 'payment'

export const BANK_PAYMENT_TEXT = {
    [BANK_SEPA_CANCELED]: 'canceled sepa',
    [BANK_TRANSFER_IN]: 'prepayment',
    [BANK_TRANSFER_OUT]: 'outgoing tranfer',
    [BANK_SEPA_IN]: 'direct debit',
    [BANK_ZAB]: 'ZAB',
    [BANK_TABEO]: 'Tabeo',
    [BANK_SPLIT_IT]: 'SplitIt',
    [BANK_PLEDG]: 'Pledg',
}



// WEBPACK FOOTER //
// ./src/modules/payment/state/const.js